import { render, staticRenderFns } from "./ModifyPwdModal.vue?vue&type=template&id=0d1c4474&scoped=true"
import script from "./ModifyPwdModal.vue?vue&type=script&lang=js"
export * from "./ModifyPwdModal.vue?vue&type=script&lang=js"
import style0 from "./ModifyPwdModal.vue?vue&type=style&index=0&id=0d1c4474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c4474",
  null
  
)

export default component.exports